export default function computeKeyColorClass(race) {
  // Return winning party class if there is one
  let winner = race.candidates.find((candidate) => candidate.is_winner);
  if (winner) {
    if (winner.party == 'dem') {
      return 'd-win';
    } else if (winner.party == 'gop') {
      return 'r-win';
    } else {
      return 'o-win';
    }
  }

  // Return leading party class if there is no tie
  let leader = race.candidates[0];
  let second = race.candidates[1];
  if ((leader && !second) || (second && leader.votes > second.votes)) {
    if (leader.party == 'dem') {
      return 'd-lead';
    } else if (leader.party == 'gop') {
      return 'r-lead';
    } else {
      return 'o-lead';
    }
  }

  // Return tie class if there is one
  if (leader && second && leader.votes == second.votes && leader.votes > 0) {
    return 'tie-win';
  }

  return '';
}
